import { teamImg, africanWebp } from "../assets/images";

function About() {
  return (
    <div className="pt-24">
      <div className="container bg-white m-auto p-6 text-gray-600 md:px-12 xl:px-6 rounded-lg">
        <div className="space-y-6 md:space-y-0 md:flex md:gap-6 lg:items-center lg:gap-12">
          <div
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-offset="200"
            className="md:w-5/12 lg:w-5/12"
          >
            <img
              src={teamImg}
              alt="Notre équipe"
              loading="lazy"
              className="w-full h-auto rounded-lg"
            />
          </div>
          <div
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-offset="200"
            className="md:w-7/12 lg:w-6/12"
          >
            <h2 className="text-2xl text-gray-900 font-bold md:text-4xl">
              Qui sommes nous ?
            </h2>
            <p className="mt-6 text-gray-600">
              Certifiée ISO 9001 version 2015 depuis septembre 2020, La société d’Importation, de Fabrication d’Alimentation Animale et de poussins est une société ivoirienne spécialisée dans la nutrition animale, production des poussins d’un jour chair et ponte, vente d’aliments finis, des Prémix TNH, des concentrés, des additifs, des aliments poisson, des œufs de consommation, des poulets de chair, des pondeuses.
            </p>
          </div>
        </div>
      </div>

      <div className="my-24">
        <div className="container bg-white m-auto p-6 text-gray-600 md:px-12 xl:px-6 rounded-lg">
          <div className="space-y-6 md:space-y-0 md:flex md:gap-6 lg:items-center justify-end lg:gap-12">
            <div
              data-aos="fade-right"
              data-aos-duration="1000"
              data-aos-offset="200"
              className="md:w-7/12 lg:w-6/12"
            >
              <h2 className="text-2xl text-gray-900 font-bold md:text-4xl">
                Notre expérience
              </h2>
              <p className="mt-6 text-gray-600">
                Grâce à notre savoir-faire, nos équipements ultra modernes et notre personnel hautement qualifié, l’entreprise s’est hissée en 2018, au rang des meilleures entreprises d’accouvage de Côte d’Ivoire et a contribué à booster l’élevage en Côte d’ Ivoire et en Afrique. Pour parfaire la qualité de ses produits, la moul bénéficie d’un réseau de partenaires nationaux et internationaux de premier ordre et représente une alternative sérieuse face à la multitude d’acteurs présents dans le secteur.
              </p>
              <p className="mt-4 text-gray-600">
                Nos clients bénéficient d’une assistance technique gratuite de choix et personnalisé, faite par une équipe de techniciens et de vétérinaires qualifiés et expérimentés pour une satisfaction parfaite.
                Des dispositions pour la prise en compte et le traitement des réclamations clients sont mises en place afin de tenir compte des exigences des clients.
              </p>
            </div>
            <div
              data-aos="fade-left"
              data-aos-duration="1000"
              data-aos-offset="200"
              className="md:w-5/12 lg:w-5/12"
            >
              <img
                src={africanWebp}
                alt="Notre expérience"
                loading="lazy"
                className="w-full h-auto rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
